var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalonSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salon_Social",
    "data-name": "Salon Social",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.951,
    height: 56.954,
    viewBox: "0 0 56.951 56.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M56.963,10.846a2.5,2.5,0,0,0-2.5-2.5H43.5V4.862A2.5,2.5,0,0,0,42.667,0H14.3a2.5,2.5,0,0,0-.833,4.864V8.343H2.509A2.5,2.5,0,0,0,1.674,13.2V51.116a.835.835,0,0,0,.835.832H18.472l-4.671,3.5a.835.835,0,0,0,.5,1.5H42.667a.835.835,0,0,0,.5-1.5l-4.671-3.5H54.461a.835.835,0,0,0,.832-.832h0V13.2a2.5,2.5,0,0,0,1.67-2.358ZM43.5,13.348H53.626V41.713H43.5ZM14.3,1.668H42.667a.835.835,0,1,1,0,1.668H17.638a.835.835,0,0,0,0,1.668h24.2V50.279H40.165V32.538a.835.835,0,0,0-.835-.838H17.638a.835.835,0,0,0-.833.835V50.287h-1.67V4.167a.835.835,0,0,0-.835-.835h0a.835.835,0,0,1,0-1.668ZM29.319,50.287V40.045h5.838V50.279Zm-7.509,0V40.045h5.84V50.279Zm14.183-11.9H20.977a.835.835,0,0,0-.835.835h0V50.287H18.473V33.371H38.5V50.279H36.828V39.211a.835.835,0,0,0-.835-.835ZM13.468,13.348V41.713H3.345V13.348ZM2.509,10.011H13.468v1.668H2.509a.835.835,0,1,1,0-1.668Zm.836,33.371H13.468v6.9H3.345Zm36.819,11.9H16.8l4.45-3.337H35.715ZM43.5,50.28v-6.9H53.622v6.9Zm10.96-38.6H43.5V10.011h10.96a.835.835,0,0,1,0,1.668Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M33.261,108.975h5.12a.835.835,0,0,0,.835-.835V98.125a.835.835,0,0,0-.835-.835h-5.12a.835.835,0,0,0-.833.835h0v10.011a.835.835,0,0,0,.833.839ZM34.1,98.964h3.448v8.342H34.1Z",
    transform: "translate(-27.426 -82.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M298.552,97.29h-5.118a.835.835,0,0,0-.833.835h0v10.011a.835.835,0,0,0,.833.839h5.118a.835.835,0,0,0,.833-.835V98.125a.835.835,0,0,0-.833-.835Zm-.835,10.013h-3.448V98.968h3.448Z",
    transform: "translate(-247.44 -82.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M33.261,195.459h5.12a.835.835,0,0,0,.835-.833V184.613a.835.835,0,0,0-.835-.833h-5.12a.833.833,0,0,0-.833.833v10.013A.833.833,0,0,0,33.261,195.459Zm.835-10.011h3.448v8.335H34.1Z",
    transform: "translate(-27.426 -155.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M298.552,183.78h-5.118a.833.833,0,0,0-.833.833v10.013a.833.833,0,0,0,.833.833h5.118a.833.833,0,0,0,.833-.833V184.613A.833.833,0,0,0,298.552,183.78Zm-.835,10.011h-3.448v-8.335h3.448Z",
    transform: "translate(-247.44 -155.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M127.112,74.48h-5.118a.835.835,0,0,0-.833.835h0V85.326a.835.835,0,0,0,.833.835h5.118a.835.835,0,0,0,.833-.835V75.315A.835.835,0,0,0,127.112,74.48Zm-.834,10.013h-3.443V76.158h3.448Z",
    transform: "translate(-102.462 -62.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M211.425,75.93h-5.11a.835.835,0,0,0-.835.832h0V86.774a.835.835,0,0,0,.835.835h5.11a.835.835,0,0,0,.833-.835V76.762A.833.833,0,0,0,211.425,75.93Zm-.835,10.011h-3.442V77.606H210.6Z",
    transform: "translate(-173.767 -64.211)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonSocial);
export default __webpack_public_path__ + "static/media/Salon Social.f8caf9290f95b6e3695dcbce6d619749.svg";
export { ForwardRef as ReactComponent };